import React from 'react'

import Component4 from '../components/component4'
import styles from './countdown.module.css'

const Countdown = (props) => {
  return (
    <div   className={styles['container']}>
      <Component4 rootClassName="root-class-name"></Component4>
    </div>
  )
}

export default Countdown
